import React, { useState, useContext } from "react";
import { BlackAndWhite } from "../../themes/Colors";
import useWindowDimensions from "../../components/get-diemensions/UseWindowDiemensions";
import { BaseButtons, TextInputField } from "../../components/atoms";
import { useNavigate } from "react-router-dom";
import { AdminContext } from "../../context/admin-context";
import { LoadingPopUp } from "../../components";

const AdminPortal = () => {
  const { width, height } = useWindowDimensions();

  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const admin = useContext(AdminContext);
  const navigate = useNavigate();

  const HandleSubmit = async () => {
    setLoading(true);
    setError("Loading");
    // authentication or login function heal
    //this code is used for Ui test
    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/cannaPos/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: username,
            password: password,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.message === "logged in" && respnseData.type === "Admin") {
        admin.login();
        admin.adminUserInfo(respnseData);
        // setLoading(false);
        navigate("/adminEditor");
      } else if (
        respnseData.message === "logged in" &&
        respnseData.type === "SubAdmin"
      ) {
        admin.login();
        admin.adminUserInfo(respnseData);
        // setLoading(false);
        navigate("/adminEditor");
      } else if (
        respnseData.message === "logged in" &&
        respnseData.type === "OwnerAdmin"
      ) {
        admin.login();
        admin.adminUserInfo(respnseData);
        // setLoading(false);
        navigate("/ownerAdminReader");
      } else if (
        respnseData.message === "logged in" &&
        respnseData.type === "Cashier"
      ) {
        admin.login();
        admin.adminUserInfo(respnseData);
        // setLoading(false);
        navigate("/cannaPosAccess");
      } else if (
        (respnseData.message === "logged in" &&
          respnseData.type === "Doctor") ||
        respnseData.type === "Practitioner"
      ) {
        admin.login();
        admin.adminUserInfo(respnseData);
        // setLoading(false);
        navigate("/docAccess");
      } else if (
        respnseData.message === "logged in" &&
        respnseData.type === "Support"
      ) {
        admin.login();
        admin.adminUserInfo(respnseData);
        // setLoading(false);
        navigate("/supportAccess");
      } else if (
        respnseData.message === "logged in" &&
        respnseData.type === "Owner"
      ) {
        admin.login();
        admin.adminUserInfo(respnseData);
        // setLoading(false);
        navigate("/storeOwner");
      } else {
        navigate("/adminPortal");
        setError("invalid credentials");
        setLoading(false);
      }
    } catch (err) {
      console.log("erro", err);
      setLoading(false);
      setError("invalid credentials");
    }
  };
  return (
    <div
      style={{
        height: height,
        width: width,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        backgroundColor: BlackAndWhite.red,
        position: "relative",
      }}
    >
      <div
        style={{
          height: width > 899 ? 600 : "100%",
          // width: width > 899 ? "40%" : "100%",
          paddingLeft: 80,
          paddingRight: 80,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: BlackAndWhite.secondary,
          borderRadius: 8,
          position: "relative",
          marginTop: 50,
        }}
      >
        <img
          alt="logo"
          src={require("../../images/rooftopLogo/RoofTopLogo5122.png")}
          style={{ height: 110, position: "absolute", top: 50 }}
        />
        <div
          style={{
            color: "#000000",
            fontSize: 22,
            marginTop: 170,
            marginBottom: 30,
          }}
        >
          ADMIN LOGIN
        </div>
        <TextInputField
          labelTitle={"USERNAME"}
          onChange={(event) => setUsername(event.target.value)}
          invert={true}
          mini={true}
          borderRadius={4}
          size={280}
        />
        <TextInputField
          labelTitle={"PASSWORD"}
          onChange={(event) => setPassword(event.target.value)}
          showPassword={true}
          invert={true}
          mini={true}
          borderRadius={4}
          size={280}
        />
        <div style={{ height: 10 }} />
        <BaseButtons
          label={"LOGIN"}
          // invert={true}
          size={310}
          onClick={() => HandleSubmit()}
          mini={true}
          borderRadius={4}
          fontWeight={"bold"}
          fontSize={18}
        />
        <div style={{ height: 10 }} />
      </div>
      <LoadingPopUp display={loading} />
    </div>
  );
};

export default AdminPortal;
